import { createClient } from "@supabase/supabase-js";
import type { Database } from "@/types/supabase";
import { env } from "@/config/env";

export const supabase = createClient<Database>(
  env.VITE_SUPABASE_URL,
  env.VITE_SUPABASE_ANON_KEY,
  {
    auth: {
      autoRefreshToken: true,
      persistSession: true,
      detectSessionInUrl: true,
      flowType: "pkce", // More secure auth flow
      // Disable navigator.locks in dev to prevent deadlock with React StrictMode double-mount.
      // Supabase's _getAccessToken() calls auth.getSession() for EVERY DB query,
      // and navigator.locks can deadlock when the first useEffect mount acquires
      // the lock but StrictMode's cleanup/re-mount creates a second competing call.
      ...(import.meta.env.DEV && {
        lock: async <R>(_name: string, _acquireTimeout: number, fn: () => Promise<R>): Promise<R> => {
          return await fn();
        },
      }),
    },
  },
);
